import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { TDriveDocId } from '../../../../../../../../types/rest/IRestDriveDoc';
import { boardOpen } from '../../../../../../base/effects/boardOpen';
import { EAuthUserPlatformType } from 'app/types/rest/IRestAuthUser';
import { getFile } from 'app/helper/authorisation/microsoft/graph/api/getFile';
import { msBuildUrl } from 'app/helper/file_helper';
import { getDriveDoc } from 'app/store/model/driveDocs/selectors/getDriveDoc';

export const onLinkClick = (
    event: React.SyntheticEvent,
    driveDocId: TDriveDocId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        dispatch(segmentTrackAction(SegmentCardEvent.ATTACHED_FILE_LINK_CLICKED));
        const attachment = getDriveDoc(state, driveDocId);
        if (attachment.dashboardId) {
            event.preventDefault(); // не открывать ссылку
            return dispatch(boardOpen(attachment.dashboardId));
        }
        if (
            attachment.platformType === EAuthUserPlatformType.MICROSOFT &&
            !attachment.url.includes('sourcedoc=') // ссылка на доки правильная, т.к. не содержит имя папки
        ) {
            event.preventDefault(); // не открывать ссылку
            getFile(attachment.driveId, attachment.fileId)
                .then(item => {
                    return msBuildUrl(item);
                })
                .then(url => {
                    window.open(url, '_blank');
                });
        }
    };
    return action;
};
